/**
 * @module 日期组件顶栏组件
 */
import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from '@jd/jmtd-tools/es/is';
import { addDate, formatDate } from '@jd/jmtd-tools/es/date';
import classNames from '@jd/jmtd-tools/es/classnames';
import ConfigConsumer from '../ConfigConsumer';
import { getLocale } from '../locale'; // 按钮图标class

var ButtonIconClasses = {
  year: 'jmti-backward-circle-f',
  month: 'jmti-play-circle-f'
};
var StepName = {
  '-1': 'prev',
  1: 'next'
};

function DatePickerHeader(_ref) {
  var disableBtn = _ref.disableBtn,
      hiddenBtn = _ref.hiddenBtn,
      date = _ref.date,
      format = _ref.format,
      onSwitch = _ref.onSwitch,
      onArrow = _ref.onArrow;

  function arrow(type, step) {
    var stepName = StepName[step]; // 转换为prev,next

    var fieldName = stepName + type.replace(/./, function (ch) {
      return ch.toUpperCase();
    }); // 转换为prevYear格式

    var disabled = disableBtn[fieldName];
    var className = classNames('jmtd-icon-font', 'jmtd-date-picker-header-btn', "jmtd-date-picker-header-btn-".concat(stepName, "-").concat(type), ButtonIconClasses[type], {
      'jmtd-date-picker-header-btn-disabled': disabled
    });
    return !hiddenBtn[fieldName] && /*#__PURE__*/React.createElement("span", {
      className: className,
      onClick: function onClick() {
        if (!disabled) {
          onArrow ? onSwitch(onArrow(date, step, type)) : onSwitch(addDate(date, step, type));
        }
      }
    });
  }

  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var _format;

    var locale = _ref2.locale;
    format = (_format = format) !== null && _format !== void 0 ? _format : getLocale(locale).datePicker.pickerHeaderFormat;
    return /*#__PURE__*/React.createElement("div", {
      className: "jmtd-date-picker-header"
    }, arrow('year', -1), arrow('month', -1), /*#__PURE__*/React.createElement("span", {
      className: "jmtd-date-picker-header-content"
    }, isFunction(format) ? format(date) : formatDate(date, format)), arrow('month', 1), arrow('year', 1));
  });
}

DatePickerHeader.propTypes = {
  date: PropTypes.any.isRequired,
  format: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  onArrow: PropTypes.func,
  onSwitch: PropTypes.func,
  disableBtn: PropTypes.object,
  hiddenBtn: PropTypes.object
};
DatePickerHeader.defaultProps = {
  format: null,
  onArrow: null,
  onSwitch: function onSwitch() {},
  disableBtn: {
    prevMonth: false,
    nextMonth: false,
    prevYear: false,
    nextYear: false
  },
  hiddenBtn: {
    prevMonth: false,
    nextMonth: false,
    prevYear: false,
    nextYear: false
  }
};
export default DatePickerHeader;